import React from 'react';
import ReactDOM from 'react-dom';

import BufferTabView from 'buffers/BufferTabView';
import {renderToDOM} from 'redux-stores/ReduxDOMRender';

import RunDetails from './RunDetails';
import RunDetailsTabState from './RunDetailsTabState';

export default class RunDetailsTabView extends BufferTabView<RunDetailsTabState> {
  override render(): this {
    const props = {
      runId: this.model.get('runId'),
    };
    renderToDOM(
      <div className="react-tab-container">
        <RunDetails {...props} />
      </div>,
      this.el
    );
    return this;
  }

  override remove(): Backbone.View<RunDetailsTabState> {
    ReactDOM.unmountComponentAtNode(this.el);
    return super.remove();
  }
}

RunDetailsTabView.prototype.className = 'buffer-tab buffer-tab--no-padding';
